







































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";
import UsersApi from "@/services/UsersApi";
import TooltipModule from "@/store/tooltip";
import AuthModule from "@/store/auth";
import axios, { AxiosResponse } from "axios";
import CTooltip from "@/components/CTooltip.vue";
import dayjs from "dayjs";
import { ZipAddressResponse } from "@/types";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class URegisterByAdmin extends Vue {
  // 郵便番号の宣言
  private postcode = "";

  // 入力フォーム
  private form = {
    name: "",
    password: "",
    confirmPassword: "",
    ugcUuid: undefined,
    detail: {
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  // 入力、表示の変更
  private inputDate = "";

  // v-menu
  private menu = false;

  // v-date-picker
  private activePicker: string | null = null;

  private mounted() {
    this.tokenCheck();
  }

  private tokenCheck() {
    // 本登録トークン取得
    const { token } = this.$route.query;

    if (!token) {
      // tokenがなければトップに戻る
      this.$router.push({ name: "Top" });
    }
  }

  // axiosを利用して郵便番号から住所の特定
  @Watch("postcode")
  private async autoCompleteAddress() {
    await axios
      .get(`https://api.zipaddress.net/?zipcode=${this.postcode}`)
      .then((response: AxiosResponse<ZipAddressResponse>) => {
        this.form.detail.prefecture = response.data.data.pref;
        this.form.detail.city = response.data.data.city;
      })
      .catch(() => {
        this.form.detail.prefecture = "";
        this.form.detail.city = "";
      });
  }

  // エラーモーダルの表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // date-pickerをchangeした時に実行
  private changeDatePicker(date: Date) {
    this.inputDate = dayjs(date).format("YYYYMMDD");
    this.menu = false;
  }

  // 誕生日を変更するごとに以下を実行
  @Watch("menu")
  private async cliclCalendar() {
    setTimeout(() => {
      this.activePicker = "YEAR";
    });
  }

  // 入力完了が押されたとき
  private async submit() {
    // 日付変換
    if (this.form.detail) {
      this.form.detail.birthday = dayjs(this.inputDate).format("YYYY-MM-DD");
    }
    // 本登録トークンの取得
    const { token } = this.$route.query;
    const UsersRes = UsersApi.createInstance(token as string);
    try {
      const UserRes = await UsersRes.createUser(this.form);
      if (!UserRes?.data?.data?.user) {
        return;
      }
      AuthModule.commitMe(UserRes.data.data.user);
      // URegisterCompに進む
      this.$router.push({ name: "URegisterComp" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
